export const locale = {
  delete: 'Delete',
  cancel: 'Cancel',
  submit: 'Submit',
  repeat_form_submit: 'Submit & Repeat',
};
